import type { StateCardDescriptionProps } from "./types";

export function StateCardDescription({ children }: StateCardDescriptionProps) {
  return (
    <p className="max-w-[240px] text-center text-xs text-secondary">
      {children}
    </p>
  );
}
